module.exports = __webpack_public_path__ + "static/media/12_Bild_4_ARM_Team_Meltin-MMI_NicolaPitaro_7660.6334eee3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle12/12_Bild_4_ARM_Team_Meltin-MMI_NicolaPitaro_7660.jpg
 ** module id = 151
 ** module chunks = 0
 **/